(function tmQAMonitor() {
    'use strict';

  // Perf guard: only run when explicitly enabled via ?tmqa=1 — never for real visitors
  if (location.search.indexOf('tmqa=1') === -1) return;

  var VERSION = '1.0.0';

  var STORE = 'techmanistan';
  var issues = [];

  function log(type, message, element) {
    var entry = {
      type: type,
      message: message,
      url: window.location.href,
      time: new Date().toISOString()
    };
    issues.push(entry);
    if (type === 'error') {
      console.error('[TM QA ' + VERSION + '] ' + message, element || '');
    } else if (type === 'warn') {
      console.warn('[TM QA ' + VERSION + '] ' + message, element || '');
    } else {
      console.log('[TM QA ' + VERSION + '] ' + message, element || '');
    }
  }

  // TEST 1: Card to PDP routing integrity
  // Every product card must have exactly one link pointing to /products/
  function testCardPDPRouting() {
    var cards = document.querySelectorAll('.tm-card-wrapper, .product-card-wrapper, .card-wrapper');
    if (!cards.length) return;
    var passed = 0;
    var failed = 0;
    cards.forEach(function(card, i) {
      var links = card.querySelectorAll('a[href]');
      var pdpLinks = Array.from(links).filter(function(a) {
        return a.getAttribute('href') && a.getAttribute('href').indexOf('/products/') !== -1;
      });
      if (pdpLinks.length === 0) {
        log('error', 'Card ' + i + ' has NO link to a product page', card);
        failed++;
      } else {
        var hrefs = pdpLinks.map(function(a){ return a.getAttribute('href'); });
        var unique = hrefs.filter(function(v, i, a){ return a.indexOf(v) === i; });
        if (unique.length > 1) {
          log('warn', 'Card ' + i + ' links to ' + unique.length + ' different products: ' + unique.join(', '), card);
        }
        passed++;
      }
    });
    log('info', 'Card PDP routing: ' + passed + ' passed, ' + failed + ' failed out of ' + cards.length + ' cards');
  }

  // TEST 2: Tap target size check
  // All interactive elements must be at least 44x44px (Apple HIG standard)
  function testTapTargets() {
    var interactive = document.querySelectorAll('a, button, [role="button"], input[type="submit"], .tm-card__atc-btn');
    var tooSmall = [];
    interactive.forEach(function(el) {
      var rect = el.getBoundingClientRect();
      if (rect.width === 0 && rect.height === 0) return;
      if (rect.width < 44 || rect.height < 44) {
        var label = el.textContent.trim().substring(0, 30) || el.getAttribute('aria-label') || el.tagName;
        tooSmall.push(label + ' (' + Math.round(rect.width) + 'x' + Math.round(rect.height) + 'px)');
      }
    });
    if (tooSmall.length > 0) {
      log('warn', 'Tap targets below 44px minimum (' + tooSmall.length + '): ' + tooSmall.slice(0, 5).join(' | '));
    } else {
      log('info', 'Tap targets: all interactive elements meet 44px minimum');
    }
  }

  // TEST 3: Overlay interception check
  // Detects if any element with high z-index is covering the ATC button or card links
  function testOverlayInterception() {
    var atcButtons = document.querySelectorAll('.tm-card__atc-btn, .product-form__submit, #tm-sticky-buy-btn');
    atcButtons.forEach(function(btn) {
      var rect = btn.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) return;
      var centerX = rect.left + rect.width / 2;
      var centerY = rect.top + rect.height / 2;
      if (centerX < 0 || centerY < 0 || centerX > window.innerWidth || centerY > window.innerHeight) return;
      var topEl = document.elementFromPoint(centerX, centerY);
      if (topEl && topEl !== btn && !btn.contains(topEl)) {
        var topTag = topEl.tagName + (topEl.className ? '.' + String(topEl.className).split(' ')[0] : '');
        log('warn', 'Button may be intercepted by overlay element: ' + topTag + ' is on top of ' + btn.className, btn);
      }
    });
  }

  // TEST 4: Link integrity after AJAX pagination
  // Re-runs card routing test after pagination loads new products
  function watchForAJAXPagination() {
    var grid = document.getElementById('ProductGridContainer') || document.getElementById('product-grid');
    if (!grid) return;
    var observer = new MutationObserver(function(mutations) {
      var hasNewNodes = mutations.some(function(m){ return m.addedNodes.length > 0; });
      if (hasNewNodes) {
        log('info', 'AJAX pagination detected — re-running link integrity checks');
        setTimeout(function() {
          testCardPDPRouting();
          testTapTargets();
          testOverlayInterception();
        }, 500);
      }
    });
    observer.observe(grid, { childList: true, subtree: true });
    log('info', 'Watching product grid for AJAX pagination changes');
  }

  // TEST 5: WhatsApp and third party overlay z-index check
  function testHighZIndexElements() {
    var all = document.querySelectorAll('*');
    var highZ = [];
    all.forEach(function(el) {
      var z = parseInt(window.getComputedStyle(el).zIndex);
      if (!isNaN(z) && z > 9000) {
        var tag = el.tagName + (el.id ? '#' + el.id : '') + (el.className ? '.' + String(el.className).split(' ')[0] : '');
        highZ.push(tag + ' (z:' + z + ')');
      }
    });
    if (highZ.length > 0) {
      log('info', 'High z-index elements found (' + highZ.length + '): ' + highZ.slice(0, 8).join(', '));
    }
  }

  // TEST 6: Merchandising change regression
  // Verifies featured collection sections still have products loaded
  function testFeaturedCollections() {
    var sections = document.querySelectorAll('[id^="collection-"]');
    sections.forEach(function(section) {
      var cards = section.querySelectorAll('.tm-card-wrapper, .card-wrapper');
      if (cards.length === 0) {
        log('error', 'Featured collection section #' + section.id + ' has no products — may be misconfigured after merchandising change', section);
      }
    });
  }

  // Expose issues for manual inspection in console
  window.tmQA = {
    version: VERSION,
    getIssues: function() { return issues; },
    getErrors: function() { return issues.filter(function(i){ return i.type === 'error'; }); },
    getWarnings: function() { return issues.filter(function(i){ return i.type === 'warn'; }); },
    rerun: function() {
      issues = [];
      runAll();
    },
    summary: function() {
      var errors = issues.filter(function(i){ return i.type === 'error'; }).length;
      var warnings = issues.filter(function(i){ return i.type === 'warn'; }).length;
      console.group('[TM QA ' + VERSION + '] Summary — ' + errors + ' errors, ' + warnings + ' warnings');
      issues.forEach(function(i){
        if (i.type === 'error') console.error(i.message);
        else if (i.type === 'warn') console.warn(i.message);
        else console.log(i.message);
      });
      console.groupEnd();
    }
  };

  function runAll() {
    var path = window.location.pathname;
    var isCollection = path.indexOf('/collections/') !== -1;
    var isProduct = path.indexOf('/products/') !== -1;
    var isHome = path === '/';

    if (isCollection || isHome) {
      testCardPDPRouting();
      testTapTargets();
      testOverlayInterception();
      testHighZIndexElements();
      testFeaturedCollections();
      watchForAJAXPagination();
    }
    if (isProduct) {
      testTapTargets();
      testOverlayInterception();
      testHighZIndexElements();
    }

    log('info', '=== TM QA v' + VERSION + ' complete on ' + path + ' — run tmQA.summary() in console for full report ===');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    setTimeout(runAll, 800);
  }

})();
